export default __webpack_public_path__ + "static/media/826.2a841faa.png";